import {
  Container,
  ColorInner,
  SelectOverlay,
  Icon,
} from './styles';
import { MODES } from './constants';

const Color = ({
  color, mode, large, huge, deleteAction, selectAction, isSelected,
}) => (
  <Container
    large={large}
    huge={huge}
    mode={mode}
    isSelected={isSelected}
    selectAction={selectAction}
  >
    <ColorInner color={color} />
    {mode === MODES.DELETE && (
      <Icon
        onClick={deleteAction ? () => deleteAction(color) : undefined}
        className="icon-close-1"
      />
    )}
    {mode === MODES.SELECT && (
      <SelectOverlay onClick={() => selectAction(color)}>
        <Icon className="icon-check-inverse" />
      </SelectOverlay>
    )}
  </Container>
);

export default Color;
